import { useFormikContext } from 'formik';

import Input from 'components/_parts/atoms/input';
import TextEditor from 'components/_parts/atoms/textEditor';

import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { UPDATE_LEVEL_PROCEESS_PARENT } from 'redux/actions/business_process';
import Label from 'components/_parts/atoms/label';
import ListData from './listDatas';
import dataDummy from './dummy';

function LeftContent({
  child, typeModal, typeTree, datas, t, loadOption,
}: any) {
  const dispatch = useDispatch();
  const formik = useFormikContext();
  const { values, errors, touched }: any = formik;
  const { listProcess, keyListProcessLevel } = ListData();
  const { listHierarcy } = dataDummy({ t });
  const { listLevel } = dataDummy({ t });

  const valueParentProcess = useMemo(() => {
    if (values.parent_id && values.parent_id_label) {
      return {
        label: values.parent_id_label, value: values.parent_id,
      };
    } if (values.parent_id_label === '') {
      return listProcess.filter((val) => values.parent_id?.includes(val.value));
    }

    return null;
  }, [values.parent_id, values.parent_id_label, listProcess]);

  const renderLevelInput = () => {
    if (typeTree !== undefined || child !== undefined || datas !== undefined) return null;

    return (
      <div>
        <Input
          id="bispro-level"
          value={listLevel?.find((val: any) => val.value === values?.level)}
          type="dropdown-windowed"
          name="level"
          placeholder="Level"
          options={listLevel}
          onChange={(e: any) => {
            formik.setFieldValue('level', e.value);
            formik.setFieldValue('parent_id', '');
            dispatch({
              type: UPDATE_LEVEL_PROCEESS_PARENT,
              payload: Number(e.value - 1),
            });
          }}
        />
      </div>
    );
  };

  const renderCategoryInput = () => {
    if (datas === undefined || values.level !== 1) return null;

    return (
      <div>
        <Input
          id="bispro-hierarchyId"
          value={listHierarcy?.filter((val: any) => values?.category?.includes(val.label))}
          type="dropdown-windowed"
          name="category"
          placeholder={t('biz_process.select_type_category')}
          options={listHierarcy}
          onChange={(e: any) => {
            formik.setFieldValue('proc_hierarchy_id', e.value);
            formik.setFieldValue('category', e.label);
          }}
        />
      </div>
    );
  };

  const getNoOptionMessage = () => (keyListProcessLevel ? 'Load Get All Data...' : t('org.structure_view.personel.form.p_option'));

  return (
    <div className="left_layout">
      <div className="tw-flex tw-flex-col tw-gap-[15px] mt-4 mx-1">
        <div>
          <Input
            id="bispro-name"
            type="text"
            name="name"
            placeholder={t('biz_process.primary.name')}
            value={values?.name}
            onChange={formik.handleChange}
            isError={errors?.name}
            validateMessage={touched?.name && errors?.name}
          />
        </div>
        {renderCategoryInput()}
        {renderLevelInput()}
        <div>
          <Input
            key={values.level}
            id="bispro-parentId"
            name="parent_id"
            type="dropdown-pagination"
            placeholder={t('org.index_view.form.select_parent')}
            value={valueParentProcess}
            disable={values.level < 2}
            loadOptions={loadOption}
            cacheUniqs={values.level}
            onChange={(e: any) => {
              formik.setFieldValue('parent_id', e.value);
              formik.setFieldValue('parent_id_label', e.label);
            }}
            noOptionsMessage={getNoOptionMessage}
          />
        </div>
        <div>
          <Label typeLabel="label_option" className="pb-2 tw-text-start">
            {t('biz_process.primary.objective')}
          </Label>
          <TextEditor
            id="text-editor-objective"
            name="objective"
            placeholder={t('biz_process.ins_objective')}
            style={{ height: '180px', paddingBottom: '5px' }}
            value={values.objective || ''}
            onChange={(e: any) => {
              formik.setFieldValue('objective', e);
            }}
          />
        </div>
        <div>
          <Label typeLabel="label_option" className="pb-2 tw-text-start">
            {t('biz_process.primary.output')}
          </Label>
          <TextEditor
            id="text-editor-output"
            name="output"
            placeholder={t('biz_process.ins_output')}
            style={{ height: '180px', paddingBottom: '5px' }}
            value={values.output || ''}
            onChange={(e: any) => {
              formik.setFieldValue('output', e);
            }}
          />
        </div>
        <div>
          <Input
            id="bispro-mainIndicator"
            type="text"
            name="main_indicator"
            placeholder={t('job_desc.detail.performance_indicator')}
            value={values?.main_indicator}
            onChange={formik.handleChange}
            isError={errors?.main_indicator}
            validateMessage={touched?.main_indicator && errors?.main_indicator}
          />
        </div>
      </div>

      <div className="tw-flex tw-flex-col tw-gap-3 mt-4 mx-1" />
    </div>
  );
}

export default LeftContent;
